import { useState } from 'react';

interface SearchBarProps {
    onSearch: (query: string) => Promise<void> | void;
    isSearching?: boolean;
}

export function SearchBar({ onSearch, isSearching = false }: SearchBarProps) {
    const [query, setQuery] = useState('');

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!query.trim()) {
            return;
        }

        console.log('Suche gestartet mit Query:', query);
        await onSearch(query);
    };

    return (
        <form onSubmit={handleSubmit} className="search-bar">
            <input
                type="text"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder="Suche nach Symbol, Keywords..."
                className="search-input"
                disabled={isSearching}
            />
            <button type="submit" className="search-button" disabled={isSearching || !query.trim()}>
                {isSearching ? (
                    <>
                        <span className="spinner"></span>
                        Suche...
                    </>
                ) : (
                    'Suchen'
                )}
            </button>
        </form>
    );
}